<script setup lang="ts">
import { computed } from 'vue'
import { usePageContext } from '@/composables/usePageContext'
import HelpLayout from '../HelpLayout.vue'

interface Article {
  id: number
  title: string
  code_name: string
}

interface CategoryContext {
  category_id: number
  category_code: string
  category_name: string
  articles: Article[]
}

const ctx = usePageContext<CategoryContext>()

const breadcrumbs = computed(() => [{ label: 'Все разделы', href: '/help/center' }, { label: ctx.category_name }])
</script>

<template>
  <HelpLayout :contact-form-category="ctx.category_code">
    <div class="help-category">
      <v-breadcrumbs :items="breadcrumbs" class="mb-5" />

      <div class="help-category__header">
        <img class="help-category__icon" :src="`/help/category_image/${ctx.category_code}`" />
        <h2 class="help-category__title" v-text="ctx.category_name" />
      </div>

      <ul class="help-category__articles">
        <li v-for="article in ctx.articles" :key="article.id">
          <a :href="`/help/article/${article.id}`">
            {{ article.title }}
          </a>
        </li>
      </ul>
    </div>
  </HelpLayout>
</template>

<style lang="scss">
@use '@/styles/pages/help/category.scss' as *;
</style>
